import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoData = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 110,
	height: 90,
	viewBox: "0 0 110 90",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 58,
			cy: 45,
			r: 45,
			fill: "#F4F4F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.75 30.25V57.75C79.75 66 75.625 71.5 66 71.5H44C34.375 71.5 30.25 66 30.25 57.75V30.25C30.25 22 34.375 16.5 44 16.5H66C75.625 16.5 79.75 22 79.75 30.25Z",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.875 23.375V28.875C61.875 31.9 64.35 34.375 67.375 34.375H72.875",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44 46.75H55",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44 57.75H66",
			stroke: "#A0A0A0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.1042 73.9323L87.7635 66.5917L95.1042 73.9323ZM87.7635 66.5917C89.0192 65.336 90.0152 63.8453 90.6948 62.2047C91.3743 60.5641 91.7241 58.8058 91.7241 57.03C91.7241 55.2543 91.3743 53.4959 90.6948 51.8553C90.0152 50.2147 89.0192 48.724 87.7635 47.4684C86.5079 46.2127 85.0172 45.2167 83.3766 44.5371C81.736 43.8576 79.9776 43.5078 78.2019 43.5078C76.4261 43.5078 74.6678 43.8576 73.0272 44.5371C71.3866 45.2167 69.8959 46.2127 68.6402 47.4684C66.1043 50.0043 64.6797 53.4437 64.6797 57.03C64.6797 60.6163 66.1043 64.0557 68.6402 66.5917C71.1762 69.1276 74.6156 70.5522 78.2019 70.5522C81.7882 70.5522 85.2276 69.1276 87.7635 66.5917Z",
			fill: "#F4F4F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.1042 73.9323L87.7635 66.5917M87.7635 66.5917C89.0192 65.336 90.0152 63.8453 90.6948 62.2047C91.3743 60.5641 91.7241 58.8058 91.7241 57.03C91.7241 55.2543 91.3743 53.4959 90.6948 51.8553C90.0152 50.2147 89.0192 48.724 87.7635 47.4684C86.5079 46.2127 85.0172 45.2167 83.3766 44.5371C81.736 43.8576 79.9777 43.5078 78.2019 43.5078C76.4261 43.5078 74.6678 43.8576 73.0272 44.5371C71.3866 45.2167 69.8959 46.2127 68.6402 47.4684C66.1043 50.0043 64.6797 53.4437 64.6797 57.03C64.6797 60.6163 66.1043 64.0557 68.6402 66.5917C71.1762 69.1276 74.6156 70.5522 78.2019 70.5522C81.7882 70.5522 85.2276 69.1276 87.7635 66.5917Z",
			stroke: "#A0A0A0",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.3449 57.0637C88.3387 59.0701 87.7374 61.0296 86.6171 62.6942C85.4969 64.3588 83.9081 65.6537 82.0518 66.415C80.1954 67.1763 78.1549 67.3699 76.1885 66.9711C74.2221 66.5724 72.4182 65.5994 71.005 64.1751C69.5918 62.7508 68.6328 60.9393 68.2494 58.9698C67.866 57.0004 68.0754 54.9615 68.8512 53.1111C69.6269 51.2606 70.9341 49.6819 72.6073 48.5747C74.2805 47.4674 76.2446 46.8814 78.251 46.8907C79.5835 46.8899 80.9029 47.1531 82.1331 47.665C83.3632 48.1769 84.4798 48.9274 85.4183 49.8733C86.3568 50.8191 87.0986 51.9415 87.601 53.1757C88.1033 54.4098 88.3561 55.7313 88.3449 57.0637ZM86.6787 57.0519C86.6806 55.3762 86.186 53.7375 85.2573 52.3428C84.3287 50.948 83.0076 49.8597 81.4608 49.2152C79.9141 48.5707 78.2111 48.399 76.5668 48.7217C74.9226 49.0445 73.4108 49.8471 72.2223 51.0284C71.0339 52.2097 70.2221 53.7166 69.8895 55.3589C69.5569 57.0012 69.7183 58.7053 70.3535 60.2559C70.9886 61.8066 72.0689 63.1342 73.458 64.0713C74.8471 65.0084 76.4827 65.5129 78.1584 65.5211C79.2775 65.5377 80.3887 65.3303 81.4266 64.9112C82.4645 64.4921 83.4081 63.8697 84.2019 63.0806C84.9958 62.2916 85.6239 61.3518 86.0492 60.3164C86.4745 59.2811 86.6886 58.1711 86.6787 57.0519Z",
			fill: "#646464"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.8937 51.0661C79.8937 51.5461 79.4658 51.8751 78.7357 51.8904C77.7133 51.9178 76.7165 52.1741 75.842 52.6343C75.4677 52.8371 75.1168 53.0709 74.7944 53.3323C74.2584 53.7435 73.7512 53.7473 73.363 53.3629C73.2764 53.2758 73.2118 53.174 73.1734 53.064C73.1351 52.9539 73.1237 52.8382 73.1401 52.7241C73.1565 52.6101 73.2003 52.5002 73.2687 52.4017C73.3371 52.3033 73.4286 52.2183 73.5372 52.1523C74.9594 50.9615 76.8536 50.2882 78.8306 50.2706C78.9616 50.2581 79.0941 50.2692 79.2199 50.3031C79.3457 50.3371 79.4621 50.3931 79.5618 50.4677C79.6616 50.5424 79.7425 50.634 79.7996 50.7369C79.8567 50.8399 79.8888 50.952 79.8937 51.0661Z",
			fill: "#646464"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 3.5,
			cy: 68.5,
			r: 3.5,
			fill: "#F5F4F4"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 17.5,
			cy: 77.5,
			r: 2.5,
			fill: "#E8E8E8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 87.5,
			cy: 2.5,
			r: 2.5,
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 106.5,
			cy: 8.5,
			r: 3.5,
			fill: "#EBEBEB"
		})
	]
});
export default SvgNoData;
